import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import autho from './modules/autho'
import order from './modules/order'
import manifestInfo from './modules/manifestInfo'
import archivme from './modules/archivme'
import receiptManagement from './modules/receiptManagement'
import addressBook from './modules/addressBook'
import outBillOrder from './modules/outBillOrder'
import outBillOrderInfo from './modules/outBillOrderInfo'
import orderEnquiry from './modules/enquiry'
import readyApply from './modules/readyApply'
import processCenter from './modules/processCenter'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    viewHeight:500
  },
  mutations: {
    UPDATEDHEIGHT(state,data){
      state.viewHeight = data
    },
  },
  actions: {
     
  },
  modules: {
    login,orderEnquiry, autho,archivme,order,receiptManagement,addressBook,outBillOrder,outBillOrderInfo,readyApply,processCenter,manifestInfo
  }
})

export default store